<template>
  <section class="section focus-section"
           data-aos="fade"
           data-aos-duration="1000"
           :class="{ 'focus_flipped' : flipped }">
    <div class="focus-section-blue-line blue-line-first"
         data-aos="fade"
         data-aos-duration="3000"></div>
    <div :class="{ 'panel_flipped' : flipped }"
         class="panel grid-x">
      <div class="panel-cell cell large-6">
        <div class="panel-cell__photo-wrapper"
             data-aos="zoom-out"
             data-aos-duration="600">
          <div
            :class="{ 'panel-cell__photo_blue-background' : flipped }"
            class="panel-cell__photo">
            <vueVimeoPlayer :video-id="videoId"
                            :options="{background: true}"
                            loop="true"
                            controls="false"
                            class="panel-cell__photo-content"/>
            <slot name="photo"/>
          </div>
        </div>
      </div>
      <div class="panel-cell cell large-6"
           data-aos="fade-up">
        <div class="panel-cell__header">
          <h2 v-text="title"
              class="panel-cell__title"/>
          <p v-text="subtext"
             class="panel-cell__subtext"/>
        </div>
        <div class="panel-cell__text">
          <slot name="bodyText"/>
        </div>
      </div>
    </div>
    <div class="focus-section-blue-line blue-line-second"
         data-aos="fade"
         data-aos-duration="3000"></div>
  </section>
</template>

<script>
import { vueVimeoPlayer } from 'vue-vimeo-player';

export default {
  name: 'TextGraphicSection',
  components: {
    vueVimeoPlayer
  },
  props: {
    title: String,
    subtext: String,
    videoId: String,
    flipped: Boolean
  }
};
</script>

<style lang="scss" scoped>
  @import "../../styles/setup/variables.scss";

  .section {
    background: rgb(244, 242, 244);
    padding-top: 250px;
    @include breakpoint(small only) {
      padding-top: 50px;
    }
    &:first-of-type {
      padding-top: 200px;
      @include breakpoint(small only) {
        padding-top: 50px;
      }
    }
    &:last-of-type {
      padding-bottom: 0;
    }
  }

  .panel {
    background: #FFFFFF;
    padding: 120px 40px 80px;

    @include breakpoint(small only) {
      padding: 80px 0 80px;
    }

    &.panel_flipped {
      flex-direction: row-reverse;

      .panel-cell {
        text-align: right;
      }
    }

    .panel-cell {
      padding: 0 40px;

      .panel-cell__header {
        color: $purp;

        .panel-cell__title {
          font-size: 46px;
        }

        .panel-cell__subtext {
          padding: 5px 0 40px;
          font-family: $sans-serif;
          font-weight: $sans-serif-weight;
          font-size: 20px;
          letter-spacing: 3px;
          text-transform: uppercase;
        }
      }

      .panel-cell__text {
        line-height: 2.2;
        color: #424242;
      }

      .panel-cell__photo-wrapper {
        width: 100%;
        text-align: center;
        margin-bottom: 10%;
        @include breakpoint(medium) {
          margin-bottom: 0;
          position: relative;
          top: -15%;
        }
        @include breakpoint(large) {
          top: -35%;
        }

        .panel-cell__photo {
          display: inline-block;
          background: $purp;
          z-index: 3;
          .panel-cell__photo-content {
            position: relative;
            top: -16px;
            left: -16px;
          }
        }

        .panel-cell__photo_blue-background {
          background: $light-blue;
        }
      }
    }
  }

  .animated-line {
    $gradient-break-pct: 75%;
    $gradient-end-pct: 100%;
    background: $light-blue;
    height: 100px;
    position: absolute;
    top: 0;
    width: 2px;
    @include breakpoint(small only){
      display: none;
    }
  }

.focus-section:not(.focus_flipped) {
  position: relative;
  &:first-of-type .focus-section-blue-line.blue-line-first {
    left: calc(25% - 1px);
  }
  .focus-section-blue-line {
    &.blue-line-first {
      left: calc(75% - 1px);
      height: 250px;
    }
    &.blue-line-second {
      left: calc(25% - 1px);
      top: 250px;
      height: 100%;
    }
    @include breakpoint(small only, medium only) {
      display: none;
    }
    @include breakpoint(large) {
      content: "";
      position: absolute;
      width: 2px;
      background: $light-blue;
      top: 0;
      z-index: 0;
    }
  }

  .panel-cell__photo-wrapper {
    z-index: 1;
  }
}

.focus_flipped {
  position: relative;
  .focus-section-blue-line {
    &.blue-line-first {
      top: 0;
      height: 250px;
      left: calc(25% - 1px);
    }
    &.blue-line-second {
      top: 250px;
      left: calc(75% - 1px);
      height: calc(100% - 250px);
    }
    @include breakpoint(small only, medium only) {
      display: none;
    }
    @include breakpoint(large) {
      content: "";
      position: absolute;
      width: 2px;
      background: $light-blue;
      right: calc(25% - 1px);
      top: 0;
      z-index: 0;
    }
  }

  .panel-cell__photo-wrapper {
    z-index: 2;
  }
}

</style>
